/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free number base converter. Convert between binary, octal, decimal, and hexadecimal — with big-number precision. Runs in your browser.`)
};

const es_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de bases numéricas. Convierte entre binario, octal, decimal y hexadecimal — con precisión de números grandes. Se ejecuta en tu navegador.`)
};

const de_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zahlenbasis-Umrechner. Rechne zwischen Binär, Oktal, Dezimal und Hexadezimal um — mit Präzision für große Zahlen. Läuft in deinem Browser.`)
};

const nl_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis getalbasiscalculator. Converteer tussen binair, octaal, decimaal en hexadecimaal — met grote getalnauwkeurigheid. Draait in uw browser.`)
};

const fr_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de base numérique gratuit. Convertissez entre binaire, octal, décimal et hexadécimal — avec précision pour les grands nombres. Fonctionne dans votre navigateur.`)
};

const it_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di basi numeriche gratuito. Converti tra binario, ottale, decimale ed esadecimale — con precisione per numeri grandi. Funziona nel tuo browser.`)
};

const pt_br2_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de bases numéricas gratuito. Converta entre binário, octal, decimal e hexadecimal — com precisão em números grandes. Executa no seu navegador.`)
};

const pt_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de base de números gratuito. Converta entre binário, octal, decimal e hexadecimal — com precisão em números grandes. Funciona no seu navegador.`)
};

const ja_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の数値ベース変換ツール。二進法、八進法、十進法、十六進法を相互変換できます。高精度な大きな数値に対応。ブラウザで動作します。`)
};

const zh_nb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的进制转换器。在二进制、八进制、十进制和十六进制之间转换，支持大数精确计算。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_tool_description", locale)
	if (locale === "en") return en_nb_tool_description(inputs)
	if (locale === "es") return es_nb_tool_description(inputs)
	if (locale === "de") return de_nb_tool_description(inputs)
	if (locale === "nl") return nl_nb_tool_description(inputs)
	if (locale === "fr") return fr_nb_tool_description(inputs)
	if (locale === "it") return it_nb_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_nb_tool_description(inputs)
	if (locale === "pt") return pt_nb_tool_description(inputs)
	if (locale === "ja") return ja_nb_tool_description(inputs)
	return zh_nb_tool_description(inputs)
};